import {
    GET_LINK_PAYMENT_STATUS_DEF,
    GET_LINK_PAYMENT_STATUS_DEF_SUCCESS,
    LINK_PAYMENT_STATUS_DEF_API_ERROR
} from "./actionTypes"

export const getLinkPaymentStatusDefList = () => ({
    type: GET_LINK_PAYMENT_STATUS_DEF,
})

export const getLinkPaymentStatusDefListSuccess = record => ({
    type: GET_LINK_PAYMENT_STATUS_DEF_SUCCESS,
    payload: record,
})

export const linkPaymentStatusDefApiError = error => {
    return {
        type: LINK_PAYMENT_STATUS_DEF_API_ERROR,
        payload: error,
    }
}
